<div class="multiSelectBox">
  <div class="row list">
    <div  class="col listItem"  *ngFor="let accessItm of list" (click)="selectItem(accessItm)" [ngClass]="highlightSelectedData(accessItm)" >{{accessItm.ArmatureDesc}}</div>
  </div>
</div>
